// @ts-check
import axios from "axios";
import { Appsettings } from "../Appsettings";
/**
 * @param {FormData} fd
 */
export async function uploadImagesApi(fd) {
  const url = Appsettings.ApiUrl + "/api/jpeg";
  const response = await axios.post(url, fd);
  if (response.status !== 200) {
    throw new Error("Error al subir las imagenes");
  }
  return response.data;
}
